module.exports = {"first":"First","previous":"Previous","next":"Next","last":"Last","yes":"Yes","no":"No","changedlocale":"Changed language"};